import React from "react";
import { Link } from "react-router-dom";
import SellerSidebar from "./common/SellerSidebar";
import ProfileSidebar from "../pages/common/ProfileSidebar";

function BulkProduct() {
  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams mb_view_hide">
              <span className="bothss">
                <Link to="">My Account</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Dashboard
                <img src="/images/brd_rowwo.png" alt="" /> Bulk product upload
              </span>
            </div>

            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              <div className="col-lg-9">
                <div className="form_boxx profilss">
                  <h3 className="bulk-product-title">
                    Bulk Upload your Products
                  </h3>
                </div>

                <div className="form_boxx bg-white ">
                  <div className="bulk-upload-card">
                    <h5 className="bulk-upload-title">Upload file</h5>

                    <label className="upload-input upload-control">
                      <span className="upload-placeholder">Upload file</span>
                      <input
                        type="file"
                        accept=".csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />
                      <img
                        className="upload-icon"
                        src="/images/pin.png"
                        alt="attach"
                      />
                    </label>

                    <div className="bulk-upload-help">
                      *supported file type is excel and CSV
                    </div>

                    <div className="text-center">
                      <button className="bulk-upload-submit">
                        Submit file
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default BulkProduct;
